// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3UgRo","row":"ProcedureTreatmentSummary_row__12TrI"};